import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const AstraLinuxNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="astralinux" />;
};
